import { useEffect, useState } from "react";
import { brandName, navItems } from "../data";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-[0_1px_0_0_transparent]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav
        className="site-container flex items-center justify-between h-16 md:h-[72px]"
        aria-label="主导航"
      >
        <a href="#top" className="flex items-center gap-2.5 group">
          <span
            className={`flex items-center justify-center w-9 h-9 rounded-lg transition-colors ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-radar-line text-lg w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
          </span>
          <span
            className={`font-serif text-lg font-bold tracking-tight whitespace-nowrap ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            {brandName}
          </span>
        </a>

        <ul
          className={`hidden lg:flex items-center gap-1 ${
            scrolled ? "text-foreground-700" : "text-background-50/90"
          }`}
        >
          {navItems.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className="inline-block px-4 py-2 text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#checklist"
            className="hidden md:inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            开始自查
            <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden flex items-center justify-center w-10 h-10 rounded-md border ${
              scrolled ? "border-background-300 text-foreground-900" : "border-background-50/40 text-background-50"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>
      </nav>

      {open ? (
        <div className="lg:hidden bg-background-50 border-b border-background-200">
          <ul className="site-container py-3 flex flex-col">
            {navItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between py-3 text-sm font-medium text-foreground-800"
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-base w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#checklist"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50 whitespace-nowrap"
              >
                开始自查
                <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      ) : null}
    </header>
  );
}